export const config = {
  api_url: "", //process.env.REACT_APP_API_END_POINT
};
